import { forwardRef } from 'react';
import { FormField, NumberInput, InputAdornment, Chips } from '@cian/ui-kit';
import { IInputWithOptionsProps } from '../../types';

import styles from './styles.css';

export const InputWithOptions = forwardRef<HTMLInputElement, IInputWithOptionsProps>(
  (
    {
      label,
      value,
      name,
      options,
      chipValue,
      onChange,
      onClickChip,
      testId = `field-${name}`,
      placeholder,
      required,
      disabled,
      isAllChipsHidden,
      rightAdornment,
      decimalDigits,
      min,
      max,
    },
    ref,
  ) => {
    return (
      <>
        <FormField label={label} required={required} dataTestId={testId} withoutMargin>
          <NumberInput
            data-testid={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            name={name}
            ref={ref}
            rightAdornment={<InputAdornment>{rightAdornment}</InputAdornment>}
            decimalDigits={decimalDigits}
            size="M"
            min={min}
            max={max}
          />
        </FormField>
        {!isAllChipsHidden && (
          <div className={styles.chips} data-testid={`${name}__chips`}>
            <Chips options={options} value={[chipValue]} onChipClick={onClickChip} size={'S'} />
          </div>
        )}
      </>
    );
  },
);

InputWithOptions.displayName = 'InputWithOptions';
